'use client'

import { useSearchParams } from 'next/navigation'
import { Children, ReactNode } from 'react'

interface Props {
  children: ReactNode
}

export function PeopleList({ children }: Props) {
  const searchParams = useSearchParams()
  const order = searchParams?.get('order')

  return (
    <>{order === 'desc' ? Children.toArray(children).reverse() : children}</>
  )
}
